import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Button, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "./contactMessagesModal.css";
import { updateContactStatus } from "../../../services/contactService";

interface Props {
  open: boolean;
  onClose: () => void;
  messages: any[];
  loading: boolean;
  onMessagesChange: React.Dispatch<React.SetStateAction<any[]>>;
}

const ContactMessagesModal = ({ open, onClose, messages, loading, onMessagesChange }: Props) => {
  const [selectedMessage, setSelectedMessage] = useState<any>(null);

  const handleStatusChange = async (id: number) => {
    try {
      await updateContactStatus(id, "Read");
      onMessagesChange((previous) =>
        previous.map((item) => (item.id === id ? { ...item, status: "Read" } : item)),
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg'>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className='contact-header'>
            <h3>Contact Messages</h3>

            <Chip label={`Total: ${messages.length}`} color='primary' size='small' />
          </div>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {loading ? (
            <div className='contact-loading'>Loading messages...</div>
          ) : messages.length === 0 ? (
            <div className='contact-empty'>No contact messages found</div>
          ) : (
            <div className='contact-table-wrapper'>
              <table className='contact-table'>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Subject</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {messages.map((msg, index) => (
                    <tr key={msg.id}>
                      <td>{index + 1}</td>

                      <td>{msg.name}</td>

                      <td>{msg.email}</td>

                      <td>{msg.subject}</td>

                      <td>{new Date(msg.created_at).toLocaleDateString()}</td>

                      <td>
  <button
    type="button"
    className={`message-status-btn ${
      msg.status?.toLowerCase() === "unread"
        ? "unread"
        : "read"
    }`}
    onClick={() => handleStatusChange(msg.id)}
  >
    {msg.status}
  </button>
</td>

                      <td>
                        <Button
                          variant='outlined'
                          size='small'
                          startIcon={<VisibilityIcon />}
                          onClick={() => setSelectedMessage(msg)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Message Details Dialog */}
      <Dialog open={Boolean(selectedMessage)} onClose={() => setSelectedMessage(null)} maxWidth='sm' fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Contact Message Details</h4>

          <IconButton onClick={() => setSelectedMessage(null)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {selectedMessage && (
            <div className='contact-detail'>
              <div className='detail-row'>
                <strong>Name:</strong>
                <span>{selectedMessage.name}</span>
              </div>

              <div className='detail-row'>
                <strong>Email:</strong>
                <span>{selectedMessage.email}</span>
              </div>

              <div className='detail-row'>
                <strong>Subject:</strong>
                <span>{selectedMessage.subject}</span>
              </div>

              <div className='detail-row'>
                <strong>Status:</strong>
                <span>{selectedMessage.status}</span>
              </div>
              <div className='detail-row'>
                <strong>Date:</strong>
                <span>{new Date(selectedMessage.created_at).toLocaleString()}</span>
              </div>

              <div className='detail-message'>
                <strong>Message</strong>

                <div className='message-box'>{selectedMessage.message}</div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContactMessagesModal;
